<template>
  <div style="display: flex;column-gap: 14px">
    <img src="@/assets/arrow.png" class="arrow" v-if="isFirst && isTopChild" @click="handleMoveStart" />
    <img src="@/assets/arrow_t.png" class="arrow" v-if="isTopChild" @click="handleMoveUp" />
    <img src="@/assets/arrow_t.png" class="arrow arrow-rotate" v-if="isEndChild" @click="handleMoveDown" />
    <img
        src="@/assets/arrow.png"
        class="arrow arrow-rotate"
        @click="handleMoveEnd"
        v-if="isFirst && isEndChild" />
  </div>
</template>

<script>
export default {
  name: "MoveArrowByFood",
  props: {
    isFirst: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default:() => {}
    },
    list: {
      type: Array,
      default:() => ([])
    },
    onChange: {
      type: Function,
      default:() => ({})
    }
  },
  data() {
    return {
      parent: {},
    }
  },
  created() {
    if(this.row?.parentCode) {
      let parent = this.handleFindParent(this.list, this.row.parentCode);
      this.parent = parent || {};
    }
  },
  methods: {
    handleMoveEnd() {
      let index = this.list.findIndex(item => item.code === this.row.code);
      this.list.splice(index, 1);
      this.list.push(this.row);
      this.onChange();
    },

    handleMoveStart() {
      let index = this.list.findIndex(item => item.code === this.row.code);
      this.list.splice(index, 1);
      this.list.unshift(this.row);
      this.onChange();
    },

    handleMoveUp() {
      if(!this.row.parentCode) {
        this.handleMove(this.list, true)
      } else {
        this.handleMove(this.parent.sub, true)
      }

    },

    handleMoveDown() {
      if(!this.row.parentCode) {
        this.handleMove(this.list, false);
      }  else {
        this.handleMove(this.parent.sub, false);
      }
    },

    // 递归，找到 row 所在的父级
    handleFindParent(list, parentCode) {
      for (const item of list) {
        if(item.code === parentCode) {
          return item;
        }

        if(item.sub && item.sub.length) {
          let parent = this.handleFindParent(item.sub, parentCode);
          if(parent) return parent;
        }
      }
    },

    handleMove(list, isUp) {
      list = list || []
      try {
        let rowIndex = list.findIndex(i => i.code === this.row.code);
        let positionIndex =
            isUp === true ? rowIndex - 1 : rowIndex + 1;
        // 把当前节点移动往前/后移动一个位置
        list.splice(rowIndex, 1);
        list.splice(positionIndex, 0, this.row);
        this.onChange();
      }catch(e) {
        console.log('e', e);
        this.$message.warning(this.$t('移动失败'));
      }
    }
  },
  computed:{
    isTopChild() {
      let index = -1;
      const sub = this.parent?.sub || [];
      let list = Object.keys(this.parent).length ? sub : this.list;
      index = list.findIndex(i => i.code === this.row.code);
      return index > 0;
    },
    isEndChild() {
      let index = -1;
      const sub = this.parent?.sub || [];
      let list = Object.keys(this.parent).length ? sub : this.list;
      index = list.findIndex(i => i.code === this.row.code);
      return index !== list.length - 1;
    }
  }
}
</script>

<style scoped>

.arrow {
  width: 30px;
  height: 30px;
}

.arrow-rotate {
  transform: rotate(180deg);
}

</style>
